import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, fmtErr } from "@/lib/api";

export default function FeedbackTab() {
  const [items, setItems] = useState([]);
  const [drafts, setDrafts] = useState({});

  const load = () => api.get("/coach/feedback").then((r) => setItems(r.data)).catch((e) => toast.error(fmtErr(e)));
  useEffect(() => { load(); }, []);

  const respond = async (id) => {
    await api.put(`/coach/feedback/${id}/response`, { response: drafts[id] || "" });
    toast.success("Response sent — client can see it now");
    setDrafts({ ...drafts, [id]: "" });
    load();
  };

  return (
    <div data-testid="coach-feedback">
      <h2 className="font-display uppercase text-4xl mb-6">Client feedback <span className="text-zinc-600">({items.length})</span></h2>
      {!items.length && <p className="text-zinc-600 text-sm">No post-workout feedback yet.</p>}
      <div className="space-y-3">
        {items.map((f) => (
          <div key={f.id} data-testid={`feedback-${f.id}`} className="border border-zinc-800 bg-zinc-950 p-5">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <p className="font-bold text-zinc-100">{f.member_name} <span className="text-zinc-500 font-normal">· {f.session_name}</span></p>
                <p className="text-xs text-zinc-500">{f.date}</p>
              </div>
              <div className="flex flex-wrap gap-2 text-[10px] uppercase tracking-[0.12em] font-bold">
                <span className="border border-zinc-700 px-2 py-1 text-zinc-300">{f.experience}</span>
                <span className="border border-zinc-700 px-2 py-1 text-zinc-300">{f.difficulty}</span>
                <span className="border border-volt/50 px-2 py-1 text-volt">RPE {f.rpe}</span>
                <span className="border border-zinc-700 px-2 py-1 text-zinc-300">Energy: {f.energy}</span>
                <span className="border border-zinc-700 px-2 py-1 text-zinc-300">Enjoy {f.enjoyment}/5</span>
              </div>
            </div>
            {f.pain && (
              <p className="mt-3 text-xs font-bold text-volt border border-volt/40 bg-volt/5 px-3 py-2" data-testid={`feedback-pain-${f.id}`}>
                ⚠ Discomfort reported — {f.pain_area || "area n/a"} ({f.pain_severity}){f.pain_exercise ? ` during ${f.pain_exercise}` : ""}{f.pain_desc ? `: ${f.pain_desc}` : ""}
              </p>
            )}
            {f.uncomfortable_exercise && (
              <p className="mt-2 text-xs text-zinc-400">Uncomfortable: {f.uncomfortable_exercise}</p>
            )}
            {f.note && <p className="mt-2 text-sm text-zinc-300 italic">“{f.note}”</p>}
            {f.trainer_response ? (
              <p className="mt-3 text-sm border-l-2 border-volt pl-3 text-zinc-300">
                <span className="text-[10px] uppercase tracking-[0.16em] text-volt font-bold block">Your response</span>
                {f.trainer_response}
              </p>
            ) : (
              <div className="mt-3 flex gap-2">
                <input placeholder="Write a short response the client will see…" value={drafts[f.id] || ""}
                  data-testid={`feedback-response-${f.id}`}
                  onChange={(e) => setDrafts({ ...drafts, [f.id]: e.target.value })}
                  className="flex-1 bg-ink border border-zinc-700 px-3 py-2.5 text-sm focus:border-volt outline-none" />
                <button onClick={() => respond(f.id)} data-testid={`feedback-respond-${f.id}`}
                  className="bg-volt text-black text-xs uppercase tracking-[0.14em] font-extrabold px-4 hover:bg-white transition-colors">
                  Reply
                </button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
